import React, { Component, Fragment } from 'react'
import { RfidElement } from '../../../views/LabelBuilder/LabelBuilder.slice'
import Heading from '../../Heading'
import ContentProperty from './ContentProperty'
import PositionProperty from './PositionProperty'

interface Props {
  selectedElement: RfidElement
}

type CombinedProps = Props

class RfidProperties extends Component<CombinedProps> {
  render () {
    const { selectedElement } = this.props
    if (!selectedElement || selectedElement.type !== 'rfid') return null

    return (
        <Fragment>
          <Heading
              className="mb-1"
              text="RFID"
              size="small" />
          <PositionProperty
              elementId={selectedElement.id}
              x={selectedElement.x}
              y={selectedElement.y}
          />
          <ContentProperty />
        </Fragment>
    )
  }
}

export default RfidProperties
